export const fcmConstant = {
  apiKey: 'AIzaSyDQ7ghkcvZVkp9JXxVDAzv_02V0vCWUE6M',
  authDomain: 'hunter-intexsoft.firebaseapp.com',
  projectId: 'hunter-intexsoft',
  storageBucket: 'hunter-intexsoft.appspot.com',
  messagingSenderId: '721255733569',
  appId: '1:721255733569:web:15b863cf9a1b208fa669c0',
  vapidKey:
    'BBPq4WWq6t_REebiyPs5-LiTN5dGV1qUCvK1vqszKizXCLgX4rRDIbdvtW-gvrn5Vq_GuopR0JBxvP3-XH_D7Gc',
};
